module.exports = __webpack_public_path__ + "img/product_93.b155cbe.webp";